import { Box, BoxProps } from "@vinomofo/components";
import { forwardRef } from "react";
import type { RefObject } from "react";
import { RelativeSizeImage } from "../relative-size-image";
// import { ScrollingWideImageContainer } from "./ScrollingWideImageContainer";
import { StorefrontImage } from "../../types";
import styled from "styled-components";

export interface OfferHeroImageWideProps extends BoxProps {
  name: string;
  image: StorefrontImage;
}

const StyledRelativeSizeImage = styled(RelativeSizeImage)`
  img {
    @media ${({ theme }) => theme.mq.max.tablet} {
      object-position: 90% bottom !important;
    }
  }
`;

const HeroBox = styled(Box)`
  transform: translateY(0);
  z-index: -1;
  max-width: 2880px;
  width: 2880px;
  margin: 0 auto;
  height: 1060px;
  left: 50%;
  margin-left: -1440px;
  position: absolute;
`;

export const OfferHeroImageMixedWide = forwardRef(
  (
    { name, image, ...rest }: OfferHeroImageWideProps,
    ref: RefObject<HTMLElement>
  ): JSX.Element => {
    return (
      // Note: Keeping this for now just in case of change of mind. :)
      // <ScrollingWideImageContainer
      //   scrollOnElementId="hero-scroll-stop"
      //   position="fixed"
      //   {...rest}
      //   ref={ref}
      //   top={[0, 35, 0]}
      // >
      <HeroBox top={[0, 35, 0]}>
        <StyledRelativeSizeImage
          name={name}
          ratio={2880 / 1060}
          image={image}
          height="100%"
        />
      </HeroBox>
      // </ScrollingWideImageContainer>
    );
  }
);

OfferHeroImageMixedWide.displayName = "OfferHeroImageMixedWide";
